export default __webpack_public_path__ + "static/media/26.1d92dfac.png";